<template>
  <div>
    <h2>
      <span class="title-small-bold">{{ t.formTitle }}</span>
      <span class="secure"
        ><ns-icon icon-name="icon-lock" /> <span>{{ t.secure }}</span></span
      >
    </h2>
    <v-text-field
      v-model="creditCardInfo.cardHolderName"
      :label="t.nameLabel"
      class="flex-column"
      :rules="rules"
      @invalid="nameUpdated"
      required
    ></v-text-field>
    <ns-credit-card
      v-model="creditCardInfo.cardNumber"
      :available-payments="paymentOptions"
      :translations="t.creditCard"
      @cardNumberUpdated="updateCardNumber"
      @paymentTypeId="updatePaymentTypeId"
      :field-disabled="editMode"
    ></ns-credit-card>
    <ns-credit-card-date
      v-model="creditCardInfo.cardDate"
      :translations="t.date"
      class="date-field"
      @cardDateUpdated="updateCardDate"
    ></ns-credit-card-date>
  </div>
</template>

<script>
import { VTextField } from "vuetify/lib";
import NsCreditCard from "./NsCreditCard.vue";
import NsCreditCardDate from "./NsCreditCardDate.vue";
import NsIcon from "../../icons/NsIcon.vue";

export default {
  name: "NsCreditCardForm",
  components: {
    VTextField,
    NsCreditCard,
    NsCreditCardDate,
    NsIcon
  },
  props: {
    /**
     * Available Payments for the market
     */
    availablePayments: {
      type: Array,
      value: []
    },
    /**
     * Translations as a key:value object
     */
    translations: {
      type: Object,
      default() {
        return {
          nameLabel: "Name on Card",
          cardNumLabel: "Card Number",
          expDateLabel: "Expiration Date",
          fieldRequired: "Field is required",
          secure: "Secure",
          formTitle: "Credit/Debit Card",
          creditCard: {
            fieldLabel: "Card Number",
            fieldRequired: "Field Required",
            notRecognizedCard: "Your card is not recognized",
            placeholder: "    -    -    -    "
          },
          date: {
            label: "Expiration Date",
            placeholder: "mm / yy",
            fieldRequired: "Required"
          }
        };
      }
    },
    /**
     * Edit Mode
     */
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: [v => !!v || this.t.fieldRequired],
      creditCardInfo: {}
    };
  },
  computed: {
    t() {
      return this.translations;
    },
    paymentOptions() {
      return this.availablePayments;
    }
  },
  methods: {
    nameUpdated(str) {
      this.$set(this.creditCardInfo, 'cardHolderName', str);
      this.$emit('credCardFormUpdated', this.creditCardInfo);
    },
    updateCardNumber(str) {
      this.$set(this.creditCardInfo, 'cardNumber', str);
      this.$emit('credCardFormUpdated', this.creditCardInfo);
    },
    updateCardDate(str) {
      if (str.length === 4) {
        let today = new Date();
        let year = today.getFullYear().toString();
        let splitYear = year.match(/.{1,2}/g);
        let shortYear = parseInt(splitYear[1]);

        let expDate = str.match(/.{1,2}/g);
        let expMonth = parseInt(expDate[0]);
        let expYear = parseInt(expDate[1]);
        this.$set(this.creditCardInfo, 'expMonth', expDate[0]);
        this.$set(this.creditCardInfo, 'expYear', expDate[1]);
        this.$emit('credCardFormUpdated', this.creditCardInfo);
      }      
    },
    updatePaymentTypeId(id) {
      this.$set(this.creditCardInfo, 'paymentTypeId', id);
      this.$emit('credCardFormUpdated', this.creditCardInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.date-field {
  max-width: 120px;
}

h2 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.secure {
  display: flex;
  font-size: 14px;
  text-transform: uppercase;
  line-height: 24px;
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);

  .icon {
    height: 20px;
    margin-top: -1px;
  }

  span {
    padding-left: 5px;
  }
}
</style>
